import React from 'react';
import { LiteraryFinals2023 } from 'views/Literaryclub2023/components';

const LifeSkillPage = () => {
  return <LiteraryFinals2023/>;
};

export default LifeSkillPage;